"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExecution = void 0;
var tslib_1 = require("tslib");
var base_1 = require("../base");
var createExecution_1 = require("./createExecution");
/**
 * This hook provides a simplified interface for creating executions.
 * It builds the execution on top of the backend passed to the BackendProvider, and workspace passed to the WorkspaceProvider.
 *
 * @beta
 */
function useExecution(config) {
    var backend = base_1.useBackend(config.backend);
    var workspace = base_1.useWorkspace(config.workspace);
    var _a = tslib_1.__read(base_1.useResolveValuesWithPlaceholders([config.seriesBy, config.slicesBy, config.totals, config.filters, config.sortBy], config.placeholdersResolutionContext), 5), seriesBy = _a[0], slicesBy = _a[1], totals = _a[2], filters = _a[3], sortBy = _a[4];
    return createExecution_1.createExecution(tslib_1.__assign(tslib_1.__assign({}, config), { backend: backend,
        workspace: workspace,
        seriesBy: seriesBy,
        slicesBy: slicesBy,
        totals: totals,
        filters: filters,
        sortBy: sortBy }));
}
exports.useExecution = useExecution;
//# sourceMappingURL=useExecution.js.map